<template>
  <section ref="section" class="section">
    <div ref="content" class="content">
      <div ref="texts" class="texts">
        <h2>
          <trans t="SECTION_EARN_TITLE"><br /></trans>
        </h2>
        <p>
          {{"SECTION_EARN_DESC".t()}}
        </p>
      </div>

      <div ref="info" class="info">
        <div class="info-top">
          <span>
          {{"SECTION_EARN_INFO_TOP".t()}}
          </span>
        </div>
        <div class="line-group">
          <div class="line">
            <div class="line-circle" />
            <div class="line-arrow" />

            <div class="line-tip">
              <trans t="SECTION_EARN_INFO_TOP_TIP"><br /></trans>
            </div>
          </div>
          <div class="line line--reverse">
            <div class="line-circle" />
            <div class="line-arrow" />

            <div class="line-tip">
              {{"SECTION_EARN_INFO_BOTTOM_TIP".t()}}
            </div>
          </div>
        </div>
        <div class="info-bottom">
          <ksd-logo/> <span>{{"SECTION_EARN_INFO_BOTTOM".t()}}</span>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import KsdLogo from './KsdLogo.vue';
import Logo from './Logo.vue';

export default {
  mounted() {
    let interSected = false;

    const observer = new IntersectionObserver(
    entries => 
    {
      entries.forEach(entry => {
        if (!interSected && entry.isIntersecting)
        {
          interSected = true;

          this.$anime({
            targets: this.$refs.content,
            scale: [0.8, 1],
            opacity: [0, 1],
            boxShadow: ['0 0 0 rgb(0 0 0 / 25%)', '0.8rem 0.8rem 0px rgb(0 0 0 / 25%)', '0.53rem 0.53rem 0 rgb(0 0 0 / 25%)',],
            duration: 1000,
            easing: "easeOutExpo",
          });

           this.$anime({
            targets: this.$refs.texts.querySelectorAll("h2, p"),
            translateY: ["50%", 0],
            translateZ: 0,
            opacity: [0, 1],
            duration: 750,
            easing: "easeOutExpo",
            delay: (el, i) => 300 + 300 * i,
          });

          this.$anime({
            targets: this.$refs.info.querySelectorAll(".info-top, .info-bottom"),
            scale: [0.9, 1],
            opacity: [0, 1],
            duration: 1000,
            easing: "easeOutExpo",
            delay: (el, i) => 300 + 300 * i,
          });

          this.$anime({
            targets: this.$refs.info.querySelectorAll(".line"),
            height: ["0%", "92%"],
            opacity: [0, 1],
            duration: 1000,
            easing: "easeOutExpo",
            delay: (el, i) => 600 + 300 * i,
          });

          this.$anime({
            targets: this.$refs.info.querySelectorAll(".line-tip"),
            opacity: [0, 1],
            duration: 1000,
            easing: "easeOutExpo",
            delay: (el, i) => 1000 + 300 * i,
          });
        }
      });
    },
    {
      threshold: 0
    });
    observer.observe(this.$refs.section);
  },
  components: {
    Logo,
    KsdLogo,
  }
}
</script>

<style scoped>
.section {
  padding: 0 2rem;
}

.content {
  display: flex;
  align-items: center;

  padding: 2.66rem 2.93rem;
  margin: 6.5rem auto;
  max-width: 87.2rem;
  width: 100%;
  background: #F3ECE6;
  border: 0.2rem solid #A59E9E;
  box-shadow: 0.8rem 0.8rem 0px rgba(0, 0, 0, 0.25);
  border-radius: 3rem;

  opacity: 0;
}

.texts {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  margin-top: -2rem;
  margin-left: 5rem;
  margin-right: 1.66rem;

  & h2 {
    font-weight: 700;
    font-size: 3.3rem;
    line-height: 1.2;
    color: #000000;
  }

  & p {
    margin-top: 1.5rem;
    margin-right: 2.66rem;
    font-weight: 600;
    font-size: 2rem;
    line-height: 1.5;
    color: #7D6C60;
  }
}

.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 2rem 1.3rem;
}

.info-top {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0.75rem 0;
  width: 36.6rem;
  height: 8.3rem;
  background: #FFF200;
  border: 0.2rem solid #7D6C60;
  box-shadow:0.3rem 0.3rem 0px #B8AA9F;
  border-radius: 4rem;

  font-weight: 700;
  font-size: 2.3rem;
  line-height: 140%;
  text-align: center;
  color: #000000;
}

.info-bottom {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 36.6rem;
  height: 8.3rem;
  background: #F7F7F7;
  border: 0.2rem solid #60554C;
  box-shadow:0.3rem 0.3rem 0px #B8AA9F;
  border-radius: 1rem;

  font-weight: 700;
  font-size: 2.3rem;
  line-height: 140%;
  color: #60554C;

  & svg {
    width: 3.6rem;
  }

  & span {
    margin-left: 0.93rem;
    margin-top: 0.2rem;
  }
}

.line-group {
  display: flex;
  justify-content: space-between;

  position: relative;
  z-index: 1;
  width: 2.5rem;
  height: 22.4rem;
}

.line {
  position: relative;
  top: 0;
  width: 0.4rem;
  height: 92%;
  background: #5E5148;
  border-radius: 1.33rem;
}

.line--reverse {
  align-self: flex-end;
  transform: scaleY(-1);
}

.line-circle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 1.6rem;
  height: 1.6rem;
  background: #F7F7FA;
  border: 0.4rem solid #5E5148;
  border-radius: 100%;
  transform: translate(-50%, -50%);
}

.line-arrow {
  position: absolute;
  bottom: 0;

  &::before {
    content: "";
    position: absolute;
    left: -0.33rem;
    bottom: 0;
    width: 0.4rem;
    height: 1rem;
    background: #5E5148;
    border-radius: 0.26rem;
    transform: rotate(-45deg);
  }

  &::after {
    content: "";
    position: absolute;
    left: 0.33rem;
    bottom: 0;
    width: 0.4rem;
    height: 1rem;
    background: #5E5148;
    border-radius: 0.26rem;
    transform: rotate(45deg);
  }
}

.line-tip {
  position: absolute;
  right: 2.26rem;
  top: 30%;

  font-weight: 600;
  font-size: 2.1rem;
  line-height: 132%;
  text-align: right;
  color: #7D6C60;
  white-space: nowrap;

  &::before {
    content: "";
    position: absolute;
    right: -2.26rem;
    top: 0.86rem;
    width: 1.86rem;
    height: 0.3rem;
    background: rgba(0, 0, 0, 0.25);
  }
}

.line--reverse .line-tip {
  left: 2.26rem;
  right: auto;
  text-align: left;
  transform: scaleY(-1);

  &::before {
    content: "";
    left: -2.26rem;
  }
}

@media (max-width: 425px) {
  .content {
    flex-direction: column-reverse;

    margin: 2rem auto;
    padding: 1rem 2rem 3rem 2rem;
    border: 0.2rem solid #A59E9E;
    box-shadow: 0.3rem 0.3rem 0 rgba(0, 0, 0, 0.25)
  }

  .info-top {
    padding: 0.75rem 0;
    width: 24.8rem;
    height: 5.8rem;
    border-radius: 4rem;

    font-size: 1.6rem;
  }

  .info-bottom {
    width: 24.8rem;
    height: 5.8rem;

    font-size: 1.6rem;

    & svg {
      width: 2.8rem;
    }
  }

  .texts {
    margin: 0 auto;
    text-align: center;

    & h2 {
      font-size: 1.8rem;
    }

    & p {
      margin: 0;
      margin-top: 1rem;
      font-size: 1.4rem;
    }
  }

  .line-group {
    width: 2.5rem;
    height: 8rem;
  }

  .line {
    width: 0.2rem;
  }

  .line-arrow {

    &::before {
      width: 0.2rem;
      height: 0.8rem;
    }

    &::after {
      width: 0.2rem;
      height: 0.8rem;
    }
  }

  .line-circle {
    width: 1rem;
    height: 1rem;
    border-width: 0.2rem;
  }

  .line-tip {
    font-size: 1.2rem;

    &::before {
      height: 0.2rem;
    }
  }
}  
</style>



// WEBPACK FOOTER //
// src/components/SectionEarn.vue